// extracted by mini-css-extract-plugin
module.exports = {"c-CommunityAside":"Aside_c-CommunityAside__2A9uW"};